import fingerprint from '../fingerprint'
import GraphQLClient from '@aspedia/graphql_client'

import commonQueries from '../queries/commonQueries'
import livePaymentMutations from '../queries/livePaymentsMutations'
import testPaymentMutations from '../queries/testPaymentMutations'

export default {
  data: function() {
    return {
      paymentProcessor: null,

      gqlClient: null,
      state: 'preparing',
      override_amount: null,
      CardValidStateTimeout: null,
      hasCardDetailsErrors: false
    }
  },
  computed: {
    paymentTesting() {
      return this.config.paymentTesting
    },
    isLoggedIn() {
      return (this.paymentProcessor) ? this.paymentProcessor.isLoggedIn() : false
    }
  },

  methods: {
    setState: function(processingState) {
      this.$set(this, 'state', processingState)
    },
    setReceiptDetails: function(receipt) {
      this.$set(this, 'receiptDetails', receipt)
    },
    setHasdDetailsErrors: function(hasErrors) {
      this.hasCardDetailsErrors = hasErrors
    },
    setPaymentTestingCardDetails: function() {
      if (this.paymentTesting) {
        const cardDetails = Object.prototype.hasOwnProperty.call(this.config, 'cardDetails') ? this.config.cardDetails : {}
        this.$set(this.newCard, 'cardholderName', Object.prototype.hasOwnProperty.call(cardDetails, 'name') ? cardDetails.name : '')
        this.$set(this.newCard, 'cardNumber', Object.prototype.hasOwnProperty.call(cardDetails, 'number') ? cardDetails.number : '')
        this.$set(this.newCard, 'expiryMonth', Object.prototype.hasOwnProperty.call(cardDetails, 'expMonth') ? cardDetails.expMonth : '')
        this.$set(this.newCard, 'expiryYear', Object.prototype.hasOwnProperty.call(cardDetails, 'expYear') ? cardDetails.expYear : '')
        this.$set(this.newCard, 'cvc', Object.prototype.hasOwnProperty.call(cardDetails, 'cvv') ? cardDetails.cvv : '')
      }
    },
    initPaymentProcessor() {
    },
    graphQLQuery: function(queryOptions) {
      return this.gqlClient.then(client => client.query(queryOptions))
    },
    graphQLMutation: function(queryOptions) {
      return this.gqlClient.then(client => client.mutate(queryOptions))
    },
    cardValidState(state, immediate = false) {
      clearTimeout(this.CardValidStateTimeout)
      if (immediate) {
        this.$set(this.newCard, 'cardValid', state)
        // Emitt and event to the Library that the card is valid and the payment is able to be processed
        this.$emit('valid-card', [state])
      }
      else {
        this.CardValidStateTimeout = setTimeout(() => {
          this.$set(this.newCard, 'cardValid', state)
          // Emitt and event to the Library that the card is valid and the payment is able to be processed
          this.$emit('valid-card', [state])
        }, 250)
      }
    },
    getCurrentLoggedInAccount() {
      return this.graphQLQuery({ opName: 'getAccountSimple' })
        .then(response => {
          return (response.data && response.data.account) ? response.data.account.id : null
        })
    }
  },

  created() {
    this.$paymentTesting = this.config.paymentTesting
    if (!this.$graphQLClient) {
      if (!this.config.uri) {
        this.config.uri = window.location.protocol + '//' + window.location.host + '/graphql'
      }

      this.gqlClient = fingerprint()
        .then(fingerprint => {
          return new GraphQLClient(
            this.config.uri,
            (this.$paymentTesting) ? commonQueries + testPaymentMutations : commonQueries + livePaymentMutations
          )
            .onQuery(context => {
              context = {
                ...context,
                headers: {
                  ...context.headers,
                  Authorization: this.config.authToken ? `Bearer ${this.config.authToken}` : null,
                  'X-Site-ID': this.config.siteid || null,
                  'X-Client-ID': fingerprint
                }
              }
              // If we are testing with recaptcha turned on - add header to indicated to the backend to use the Testing Rechaptcha Secret
              if (Object.prototype.hasOwnProperty.call(this.config.recaptcha, 'key') && this.config.paymentTesting) {
                context.headers['X-Recaptcha-Testing'] = 1
              }
              return context
            })
        })
    }
    else {
      this.gqlClient = fingerprint()
        .then(fingerprint => {
          return this.$graphQLClient(null, (this.$paymentTesting) ? commonQueries + testPaymentMutations : commonQueries + livePaymentMutations)
            .onQuery(context => {
              return {
                ...context,
                headers: {
                  ...context.headers,
                  'X-Client-ID': fingerprint
                }
              }
            })
        })
    }
  }
}
